export default __webpack_public_path__ + "static/PromptIconEight-e8740ee884f4695192ce0740196e2630.png";